import { cn, createBEM } from "@/libs";
import {Button, ButtonProps, Toast} from 'antd-mobile';
import "./index.scss";
import { useEffect } from "react";

interface SubmitBtn extends ButtonProps{
  className: string;
  
} 

const b = createBEM("i-submit-btn");
const actions:any  = {
  'onClick': () => {}
}
export const SubmitBtn = ({className, onClick, ...rest}: ButtonProps) => {
  useEffect(() => {
    actions.onClick = onClick;
  }, [onClick])
  useEffect(() => {
    const _onClick = (e:any) => {
      if(
        e.keyCode === '13' 
        || e.key === 'Enter' 
        || e.code === 'Enter'){
        typeof actions.onClick === 'function' && actions.onClick(e);
      }
    }
    window.addEventListener('keyup', _onClick);
    return () => {
      window.removeEventListener('keyup', _onClick);
    }
  }, [])
  return <Button className={cn(b(), className)} {...rest} onClick={onClick}/>;
};
